import { UsersOrderByEnum, useUsers } from '@/api/user/user.api';
import { UserShowcaseSearchDto } from '@/types';
import { useEffect, useState } from 'react';
import ShowcaseHighlight from './ShowcaseHighlight/ShowcaseHighlight';
import TopShowcases from './TopShowcases/TopShowcases';

const ShowcasesPageHeader = () => {
  const [selectedShowcase, setSelectedShowcase] = useState<UserShowcaseSearchDto>();
  const [orderBy, setOrderBy] = useState<UsersOrderByEnum>('followersCount');
  const { data: showcases, isLoading } = useUsers({ orderBy, limit: 10 });

  useEffect(() => {
    if (showcases?.length && !selectedShowcase) {
      setSelectedShowcase(showcases[0]);
    }
  }, [showcases, selectedShowcase]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (showcases?.length) {
        const randomIndex = Math.floor(Math.random() * showcases.length);
        setSelectedShowcase(showcases[randomIndex]);
      }
    }, 10000);

    return () => clearInterval(interval);
  }, [showcases, selectedShowcase]);

  return (
    <div className="flex flex-col xl:flex-row text-left">
      <div className="flex-1">
        {selectedShowcase && <ShowcaseHighlight showcase={selectedShowcase} />}
      </div>
      <div className="w-full xl:w-[520px]">
        <TopShowcases
          orderBy={orderBy}
          setOrderBy={setOrderBy}
          isLoading={isLoading}
          showcases={showcases}
          setSelectedShowcase={setSelectedShowcase}
        />
      </div>
    </div>
  );
};

export default ShowcasesPageHeader;
